import { render, staticRenderFns } from "./TabErrors.vue?vue&type=template&id=6fe9305b&scoped=true&"
import script from "./TabErrors.vue?vue&type=script&lang=js&"
export * from "./TabErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9305b",
  null
  
)

export default component.exports